
const paData = [
  {
      "beneficiaryFirstName": "MFNAME",
      "beneficiaryLastName": "MLNAME",
      "beneficiaryDOB": "MM/DD/YYYY",
      "beneficiaryID": "XXXXXXXXX",
      "daysSupply": "",
      "numberRefills": "0",
      "requestId": null,
      "authNumber": "WEB00000000000000001",
      "assignedAuthNumber": null,
      "npiNumber": "XXXXXXXXXX",
      "priorAuthStatus": "In Progress",
      "providerName": "TEST PROVIDER",
      "providerType": "PH",
      "providerFax": null,
      "providerPhone": null,
      "providerIsPrescriber": false,
      "prescriberNPI": "XXXXXXXXXX",
      "prescriberSpecialty": null,
      "prescriberFirstName": "PFNAME",
      "prescriberLastName": "PLNAME",
      "prescriberFax": "1111111111",
      "prescriberPhone": "1111111111",
      "submitterFirstName": "SFNAME",
      "submitterLastName": "SLNAME",
      "submitterContactPhone": "1111111111",
      "submitterHippaSecureFax": "1111111111",
      "drugFormData": null,
      "drugName": "DIAZEPAM",
      "drugForm": "KIT",
      "drugStrength": "12.5-15-20",
      "trialAPIStatus": null,
      "quantity": "",
      "compoundDosageFormCd": "",
      "compoundDispUnitFormInd": "0",
      "patientName": null,
      "patientHeight": "55",
      "patientWeight": "100",
      "beneficiaryLocation": "12",
      "drugNamePrefilled": null,
      "quantityPrefilled": null,
      "daysSupplyPrefilled": null,
      "dawSelectionCode": "0",
      "requestType": "New Request",
      "requestBeginDate": "03/11/2025",
      "requestEndDate": "03/15/2025",
      "diagnosisCount": null,
      "diagnosisCodes": [
          {
              "diagnosisCdQlfr": "02",
              "diagnosisCd": "322"
          },
          {
              "diagnosisCdQlfr": "02",
              "diagnosisCd": "3242"
          }
      ],
      "trialFailure": "AI_3_11",
      "clinicalInformation": "AI_3_11",
      "additionalInformation": "Uploaded 1 document.",
      "attachments": [
          {
              "name": "cam_Pinkflower_20250829135931.jpg",
              "lastModifiedDate": "2025-08-29T17:59:32.000+0000"
          }
      ],
      "compounds": [
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          }
      ],
      "errorMessage": null,
      "ndc": "43386028101",
      "resendVerbiage": "",
      "transactionCd": "P4-P.A. Request",
      "frxPaStatusCd": "F-Deferred",
      "dispositionNote": "Prior Authorization request is in progress",
      "issueStatus": null,
      "responseCode": null,
      "uniqueSessionID": null,
      "callCategory": null,
      "rejectCode1": null,
      "internalErrorCodes1": null,
      "externalConditionCode": null,
      "internalConditionCode": null,
      "tReqId": null,
      "searchBy": null,
      "isCompound": false
  },
  {
      "beneficiaryFirstName": "MFNAME",
      "beneficiaryLastName": "MLNAME",
      "beneficiaryDOB": "MM/DD/YYYY",
      "beneficiaryID": "XXXXXXXXX",
      "daysSupply": "999",
      "numberRefills": "0",
      "requestId": null,
      "authNumber": "WEB00000000000000002",
      "assignedAuthNumber": null,
      "npiNumber": "XXXXXXXXXX",
      "priorAuthStatus": "IN PROGRESS",
      "providerName": "TEST PROVIDER",
      "providerType": "PH",
      "providerFax": null,
      "providerPhone": null,
      "providerIsPrescriber": false,
      "prescriberNPI": "XXXXXXXXXX",
      "prescriberSpecialty": null,
      "prescriberFirstName": "PFNAME",
      "prescriberLastName": "PLNAME",
      "prescriberFax": "1111111111",
      "prescriberPhone": "1111111111",
      "submitterFirstName": "SFNAME",
      "submitterLastName": "SLNAME",
      "submitterContactPhone": "1111111111",
      "submitterHippaSecureFax": "1111111111",
      "drugFormData": null,
      "drugName": "SIMVASTATIN 20 MG/5 ML SUSP",
      "drugForm": "ORAL SUSP",
      "drugStrength": "20 MG/5 ML",
      "trialAPIStatus": null,
      "quantity": "999.0",
      "compoundDosageFormCd": "",
      "compoundDispUnitFormInd": "0",
      "patientName": null,
      "patientHeight": "",
      "patientWeight": "",
      "beneficiaryLocation": "01",
      "drugNamePrefilled": null,
      "quantityPrefilled": null,
      "daysSupplyPrefilled": null,
      "dawSelectionCode": "0",
      "requestType": "New Request",
      "requestBeginDate": "08/29/2025",
      "requestEndDate": "08/31/2025",
      "diagnosisCount": null,
      "diagnosisCodes": [
          {
              "diagnosisCdQlfr": "02",
              "diagnosisCd": "test"
          }
      ],
      "trialFailure": "Tried/Considered Drugs",
      "clinicalInformation": "",
      "additionalInformation": "8/29/25, 10:44:01 AM (PT): Additional Clinical Information8/29/25, 10:48:21 AM (PT): Adding more info",
      "attachments": [
          {
              "name": "cam_PA_SUMMARY_20250905192410.pdf",
              "uploadDate": "Fri Aug 29 2025 10:39:51 GMT-0700 (Pacific Daylight Time)"
          }
      ],
      "compounds": [
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          },
          {
              "productIdQlfr": "",
              "productId": "",
              "ingredientQty": ""
          }
      ],
      "errorMessage": null,
      "ndc": null,
      "resendVerbiage": null,
      "transactionCd": "P4-P.A. Request",
      "frxPaStatusCd": "F-Deferred",
      "dispositionNote": "Prior Authorization request is in progress",
      "issueStatus": null,
      "responseCode": null,
      "uniqueSessionID": null,
      "callCategory": null,
      "rejectCode1": null,
      "internalErrorCodes1": null,
      "externalConditionCode": null,
      "internalConditionCode": null,
      "tReqId": null,
      "searchBy": null,
      "isCompound": false
  },
  {
    "additionalInformation": "NILAY SINGH IS TESTING 3",
    "attachments": [],
    "requestId": "ABCDEFGHG12345",
    "beneficiaryDOB": "06/17/1987",
    "beneficiaryFirstName": "Nilay",
    "beneficiaryID": "12345678A",
    "beneficiaryLastName": "Singh",
    "beneficiaryLocation": "14",
    "clinicalInformation": "SOME TEXT",
    "isCompound": true,
    "dawSelectionCode": "16",
    "daysSupply": "300",
    "daysSupplyPrefilled": null,
    "diagnosisCodes": [
      {
        "diagnosisCdQlfr": "02",
        "diagnosisCd": "upd01"
      },
      {
        "diagnosisCdQlfr": "07",
        "diagnosisCd": "upd02"
      }
    ],
    "drugForm": "CAPSULE",
    "drugFormData": null,
    "drugName": "DRUG LABEL                                               END",
    "drugNamePrefilled": null,
    "drugStrength": "25mg",
    "errorMessage": null,
    "npiNumber": "1234567893",
    "numberRefills": "2",
    "patientHeight": "76 inches",
    "patientName": null,
    "patientWeight": "180 lbs",
    "prescriberFax": null,
    "prescriberFirstName": "PRESCRIB LAST N",
    "prescriberLastName": "PRESCRIB LAST N",
    "prescriberNPI": "1234567893",
    "prescriberPhone": null,
    "prescriberSpecialty": null,
    "priorAuthStatus": "IN PROGRESS",
    "providerFax": null,
    "providerIsPrescriber": true,
    "providerName": "Walgreens",
    "providerPhone": null,
    "providerType": "PH",
    "quantity": "0.9",
    "quantityPrefilled": null,
    "requestBeginDate": "01/01/2020",
    "requestEndDate": "01/01/3000",
    "resendVerbiage": `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi egestas lectus ut libero vehicula, quis faucibus nunc dictum. Integer sit amet nunc risus. Aliquam tempus purus nunc, vitae molestie ante porta ac. Integer sagittis at dolor ac imperdiet. Nullam aliquet velit in lorem mattis ultricies. Mauris finibus leo et neque dictum, non semper est lobortis. Nullam mollis pharetra ipsum at gravida. Aenean vitae dictum nisi. Pellentesque imperdiet, quam vitae aliquam vehicula, orci metus tincidunt mauris, quis commodo augue nibh quis nisi. Sed quis eleifend est, a pulvinar odio. Phasellus tristique nec quam sed ullamcorper. Sed sollicitudin nulla eget semper maximus. Nullam sit amet erat sit amet metus ullamcorper venenatis. Fusce vel mollis ipsum.Donec pulvinar pretium tortor. Duis vulputate urna semper urna pellentesque, quis ornare dui elementum. Praesent quis dapibus lacus, sit amet pretium arcu. Pellentesque quis mi et tellus gravida rhoncus sit amet non orci. Donec turpis enim, efficitur at neque eget, suscipit suscipit justo. Nam ligula sapien, ullamcorper vel metus vitae, dignissim luctus dolor. Sed sed tellus elit. Etiam eu ex non ante aliquet tincidunt.
    Fusce consectetur vulputate metus eu facilisis. Nam tempus dignissim dolor, a sollicitudin lacus volutpat quis. Curabitur ac metus sem. Mauris vel tincidunt dui. Phasellus ac finibus turpis. Sed a lorem volutpat, tristique erat in, ullamcorper ante. Suspendisse pellentesque lorem lacus, eu feugiat nunc tincidunt vitae. Ut in pretium diam. Curabitur ligula nunc, aliquam id volutpat eu, ornare at eros. Proin quis finibus metus, id porttitor turpis. Fusce suscipit, odio et gravida volutpat, enim enim accumsan dui, eget placerat diam augue ac erat. Praesent ac purus ut neque consectetur interdum non vel ante. Sed nulla dolor, tristique vel vehicula sed, luctus eu velit.
    
    Donec dignissim, enim id varius volutpat, nisl neque pulvinar urna, eu pharetra massa felis eget odio. Sed pretium volutpat neque id aliquam. Vestibulum ut porta leo. Pellentesque sem nulla, placerat sed maximus ac, aliquet sit amet mauris. Ut eleifend, nibh at tristique pulvinar, dui enim aliquam tortor, id fringilla nisi nisi quis nunc. Praesent pharetra id ligula et faucibus. Nam mattis suscipit mauris, sed iaculis risus sodales finibus. Mauris vitae diam purus. Donec mollis felis metus, ac molestie dolor mattis molestie. Sed hendrerit a ex consequat tincidunt. Nunc ornare sagittis sagittis. Maecenas malesuada leo in sem malesuada lacinia. Pellentesque a tempus elit. Vestibulum quis porta ante, a tempor augue. Pellentesque facilisis, sem ac egestas commodo, massa ante aliquet nisl, id sollicitudin erat enim eget lectus. Praesent ullamcorper scelerisque purus, vitae aliquet odio sollicitudin eget.
    
    Aenean vehicula tristique augue, nec tempus elit vulputate sed. Aliquam et sodales nulla, vel pellentesque ligula. Vivamus faucibus dapibus risus ac molestie. Aliquam tincidunt varius mi, sed congue magna iaculis et. Nullam feugiat turpis vel ante aliquam aliquet. Vestibulum porttitor, justo sit amet varius pharetra, nibh lectus aliquet nisl, vitae suscipit sapien eros in nisl. Proin tempus dui sapien, sed dignissim magna consectetur a. Aliquam lobortis tristique leo, id convallis elit elementum et. Phasellus mollis velit vulputate sapien rutrum, non dignissim dolor lacinia. Nam vel nisl ut nulla luctus vestibulum. Sed sagittis facilisis ligula. Aenean eu quam in lectus hendrerit vestibulum quis vel odio. Suspendisse in dui vitae tellus dignissim posuere id quis risus.
    
    Ut non tristique lorem. Suspendisse vehicula sollicitudin lorem id varius. Fusce ex dui, pretium in luctus id, congue id lorem. Pellentesque sapien arcu, placerat ac mauris nec, vulputate varius magna. Fusce in eros ut erat aliquam mattis et quis lacus. Sed nec enim condimentum ligula molestie placerat. Maecenas quis auctor dui. Nulla sollicitudin vehicula interdum. Ut a enim non magna tincidunt ultricies. In eu ultricies lectus. Phasellus feugiat, ligula sit amet auctor porta, urna ex vestibulum massa, at convallis arcu leo eu nisi.
    
    Pellentesque sit amet mauris lorem. Donec commodo lectus ac facilisis feugiat. Nullam rutrum dictum risus, elementum rutrum erat placerat quis. Duis posuere commodo magna quis suscipit. In hac habitasse platea dictumst. Nam a purus libero. Donec vel bibendum odio.
    
    Donec rutrum bibendum est vel tincidunt. Aenean vel augue fermentum, convallis dolor vitae, vehicula libero. Vivamus eu imperdiet mi. In quis leo risus. Curabitur in porta libero. In sit amet egestas libero. Morbi pretium commodo ipsum, rutrum gravida lacus suscipit vel. Donec pellentesque, velit et vulputate vestibulum, risus metus vulputate diam, eget pulvinar mauris neque id ligula. Etiam interdum commodo justo, eget varius eros iaculis et. Donec eros ligula, mollis sit amet scelerisque vitae, fermentum eu purus. In porta sapien quis semper cursus. Curabitur at finibus ipsum, vel bibendum nisl. In ornare turpis risus, eget cursus lectus duis.`,
    "requestType": null,
    "submitterContactPhone": "4445556666",
    "submitterFirstName": "Requestor name                       END",
    "submitterHippaSecureFax": "5556667777",
    "submitterLastName": "Requestor name                       END",
    "trialAPIStatus": null,
    "trialFailure": "NILAY SINGH IS TESTING T",
    "compounds": [
      {productIdQlfr: "03", productId: '11111111', ingredientQty: '1'},
      {productIdQlfr: "03", productId: '222222222', ingredientQty: '2'}
    ]
  }
]

export default paData

